import { object, string, array, number } from 'yup';

export const addOrderLineSchema = () => {
  return object().shape({
    product: array().of(
      object().shape({
        quantity: number().required(),
        itemId: string().required(),
        variant: string(),
        config: string(),
      })
    ),
  });
};
